<template>
  <div class="box">
    <img src="../assets/wasteland.png" />
    <div class="container">建设中</div>
  </div>
</template>

<script>
export default {
  name: 'Download',
}
</script>

<style lang="scss" scoped>
.box {
  background-image: linear-gradient(#ededed, #fff, #fff);
  padding-top: 0.6rem;
  height: calc(100vh - 208px);
}
.container {
  width: 12rem;
  margin: auto;
  text-align: center;

  color: #bbb;
}
img {
  width: 4rem;
  margin: 0 auto;
  display: block;
}
</style>
